import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Root = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1.5),
}));

export const HeaderRow = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1.5),
}));

export const BellTile = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 40,
  height: 40,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "#F5B700",
  color: "#111111",

  "& svg": {
    width: 22,
    height: 22,
  },
}));

export const Chip = styled(Box)({
  padding: "4px 10px",
  borderRadius: 999,
  fontSize: 10,
  fontWeight: 700,
  letterSpacing: "0.8px",
  backgroundColor: "#FDECEC",
  color: "#C62828",
});

export const Headline = styled(Typography)({
  fontSize: 24,
  fontWeight: 700,
  lineHeight: 1.25,
});

export const Subhead = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  color: theme.palette.text.secondary,
}));

export const Bullets = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(1),
}));

export const Bullet = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: theme.spacing(1),
}));

export const BulletCheck = styled(Box)({
  display: "flex",
  flexShrink: 0,
  marginTop: 1,
  color: "#26BD6C",

  "& svg": {
    width: 16,
    height: 16,
  },
});

export const BulletText = styled(Typography)({
  fontSize: 13.5,
  lineHeight: 1.4,
});
